import {Injectable} from '@angular/core';
import * as base64 from '@juanelas/base64';
import {constants, deflate, inflate} from 'pako';

@Injectable()
export class UrlHelperService {

    public static encodeDataToBase64<T>(data: T): string {
        // Remove nulls to reduce the size
        const json = JSON.stringify(data, (k, v) => v === null ? undefined : v);
        const compressed = deflate(json, {
            level:      9,
            windowBits: 15, // JSON has many repeated keys and structures. Larger dictionary finds patterns better.
            memLevel:   9, // Use more memory
            strategy:   constants.Z_DEFAULT_STRATEGY
        });

        return base64.encode(compressed, true, false);
    }

    public static decodeDataFromBase64<T>(base64EncodedWidgetDef: string): T {
        const compressed = base64.decode(base64EncodedWidgetDef);
        const json = inflate(compressed, {to: 'string'});

        return JSON.parse(json);
    }

}
